import BaseNormalizer from "./BaseNormalizer";

const merchantStoreShippingAddressesNormalizer = Object.create(
  BaseNormalizer,
).init([
  "id",
  "city",
  "countryCode",
  "merchantStoreId",
  "otherDetails",
  "postalCode",
  "recipientAddition",
  "recipientName",
  "stateCode",
  "street",
  "streetAddition1",
  "validFrom",
  "validUntil",
]);

export default merchantStoreShippingAddressesNormalizer;
